import { Modal, Button } from "react-bootstrap";

const UnsavedChangesModal = ({ show, onLeave, onStay }) => {
  return (
    <Modal show={show} onHide={onStay} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Unsaved Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You have unsaved changes. Are you sure you want to leave without saving?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onStay}>Stay</Button>
        <Button variant="danger" onClick={onLeave}>
          Leave
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnsavedChangesModal;
